import { render, staticRenderFns } from "./JwJiaocaiKucuninfoModal.vue?vue&type=template&id=839f6800"
import script from "./JwJiaocaiKucuninfoModal.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiKucuninfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports